import { Injectable } from '@angular/core';
import moment from 'moment';
import { Router } from '@angular/router';
import { BehaviorSubject, from } from "rxjs";
import { UtilityService } from '../../../../app/shared/service/utility/utility.service';
import { HttpClient, HttpParams } from "@angular/common/http";
import locations from "../../../../assets/demo/data/location.json";
import { UserEndPoint, AppRoutes, AdminEndPoint } from "../../../../app/shared/lib/api-constant";
import { StorageService } from "../../../../app/shared/service/storage/storage.service";
import { MessageService } from 'primeng/api';
@Injectable({
  providedIn: 'root'
})
export class CommonService {

  private sameRouteReloadPromise = new BehaviorSubject<boolean>(false);
  public $sameRouteReload = this.sameRouteReloadPromise.asObservable();
  customDatePipe: any;

  constructor(
    protected http: HttpClient,
    protected utilityService: UtilityService,
    private storageService: StorageService,
    private messageService: MessageService,
    protected router: Router,
  ) {
  }

  public updateSameRouteNavigation(value: any) {
    this.sameRouteReloadPromise.next(value);
  }

  mapOrder(array: any, order: any, key: any) {

    array.sort(function (a: any, b: any) {
      var A = a[key], B = b[key];

      if (order.indexOf(A) > order.indexOf(B)) {
        return 1;
      } else {
        return -1;
      }

    });

    return array;
  };

  public removeFromArray(elem: any = {}, records: Array<any> = []) {
    const index = records.indexOf(elem);
    if (index > -1) {
      records.splice(index, 1);
    }
  }

  public pointsToPath(from: any, to: any, invertArc = true) {
    var arcPointX = (from.x + to.x) / (invertArc ? 2.4 : 1.6),
      arcPointY = (from.y + to.y) / (invertArc ? 2.4 : 1.6);
    if (!invertArc) {
      return 'M' + from.x + ',' + from.y + ',' + to.x + ' ' + to.y;
    } else {
      return 'M' + from.x + ',' + from.y + 'Q' + arcPointX + ' ' + arcPointY +
        ',' + to.x + ' ' + to.y;
    }

  }

  exportPdf(fileName: string, columns: Array<any> = [], record: Array<any> = []) {
    import("jspdf").then((jsPDF: any) => {
      import("jspdf-autotable").then(x => {
        const doc: any = new jsPDF.default(0, 0);
        doc.autoTable(columns, record);
        doc.save(fileName + '.pdf');
      })
    })
  }


  //#region TNT common service

  getCompany() {
    return this.http.get(UserEndPoint.CommonService.COMPANY);
  }

  getCompanyUser(requestUserId: string) {
    const params = new HttpParams().set('requestUserId', requestUserId);
    return this.http.get(UserEndPoint.CommonService.COMPANY_USER, { params });
  }

  getRegion() {
    return this.http.get(UserEndPoint.CommonService.COUNTRY_REGION);
  }

  getCountry() {
    return this.http.get(UserEndPoint.CommonService.COUNTRY);
  }

  getportsLocations() {
    return locations;
  }

  getEvents(body: any = {}) {
    return this.http.post(
      UserEndPoint.CommonService.EVENTS_LIST,
      body
    );
  }

  getPOA(body: any = {}) {
    return this.http.post<any>(UserEndPoint.CommonService.POA, body);
  }

  getPOD(body: any = {}) {
    return this.http.post<any>(UserEndPoint.CommonService.POD, body);
  }

  getMasterEvents() {
    return this.http.get<any>(UserEndPoint.CommonService.MASTER_EVENTS)
  }
  //#endregion TNT common service

  formatDateforoutput(date: string | Date): string {
    return this.customDatePipe.transform(date);
  }

  formatDate(date: any, format: boolean = false) {
    let input = moment(date, 'YYYY-MM-DD')
    if (input.isValid()) {
      if (format) {
        return moment(date, 'YYYY-MM-DD').format('DD MMM YYYY')
      } else {
        return input.toDate();
      }
    }
    return date;
  }
  formatDate1(date: string, format: boolean = false): string | Date {
    let input = moment(date, moment.ISO_8601, true);
    if (input.isValid()) {
      if (format) {
        return input.format('DD MMM YYYY');
      } else {
        return input.toDate();
      }
    }
    return date;
  }


  formatDateWithTime(date: any) {
    let input = moment(date, 'YYYY-MM-DD')
    if (input.isValid()) {
      return moment(date, 'YYYY-MM-DD').format('DD MMM YYYY HH:mm')
    }
    return date;
  }

  formatDateWithTimeForEventManager(date: any) {
    let input = moment(date, 'YYYY-MM-DD')
    if (input.isValid()) {
      return moment(date).format('DD MMM YYYY HH:mm')
    }
    return date;
  }

  formatDateWithTimeForLastSentOn(date: any) {
    let input = moment(date)
    if (input.isValid()) {
      return moment(date).format('DD MMM YYYY HH:mm:ss')
    }
    return date;
  }

  formatDateForReprocessing(date: any) {
    let input = moment(date, 'YYYY-MM-DD HH:mm:ss')
    if (input.isValid()) {
      return input.toDate();
    }
    return date;
  }

  formatDateForAPI(date: Date): string {
    console.log(date);
    const now = new Date(); // get current local time

    // Combine selected date (Y/M/D) with current local time (H/M/S)
    const localDateTime = moment({
      year: date.getFullYear(),
      month: date.getMonth(),
      day: date.getDate(),
      hour: now.getHours(),
      minute: now.getMinutes(),
      second: now.getSeconds()
    });
    console.log(localDateTime.local().format('YYYY-MM-DDTHH:mm:ss'));
    // Convert to UTC and return formatted string
    return localDateTime.utc().format('YYYY-MM-DDTHH:mm:ss');
    return [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, '0'),
      String(date.getDate()).padStart(2, '0'),
    ].join('-') + 'T' + [
      String(date.getHours()).padStart(2, '0'),
      String(date.getMinutes()).padStart(2, '0'),
      String(date.getSeconds()).padStart(2, '0'),
    ].join(':');
  }

  formatDateforInput(date: any) {
    let input = moment(date, 'YYYY-MM-DD')
    if (input.isValid()) {
      return moment(date).format('YYYY-MM-DDTHH:mm:ss')
    }
    return date;
  }

  formatExceptionDateWithTime(date: any) {
    if (!date)
      return;
    let input = moment(date, 'YYYY-MM-DD')
    if (input.isValid()) {
      return moment(date, 'YYYY-MM-DD').format('DD MMM YYYY')
    }
    return date;
  }

  getFormattedCurrentDate() {
    return moment().format('DD MMM YYYY');
  }

  formatDateWithTimeForDocument(date: any) {
    let input = moment(date, 'YYYY-MM-DD')
    if (input.isValid()) {
      return moment(date, 'YYYY-MM-DD').format('DD MMM YYYY')
    }
    return date;
  }

  formatDateWithTimeForDocumentDistribution(date: any) {
    let input = moment(date, 'YYYY-MM-DDTHH:mm:ss')
    if (input.isValid()) {
      return input.format('DD MMM YYYY')
      // return input.format('DD MMM YYYY | HH:mm')
    }
    return date;
  }
  convertToDate(value: any): Date | any {
    if (typeof value === "string") {
      const parsedDate = new Date(value);
      if (!isNaN(parsedDate.getTime())) {
        return parsedDate;
      }
    }
    return value;
  }

  getCurrentDate() {
    return moment().format('YYYY-MM-DD');
  }

  getCurrentDateTime() {
    return moment().utc().format('YYYY-MM-DD');
  }

  getMonthDifferenceWithTime(numberOfMonths: number) {
    return moment().utc().subtract(numberOfMonths, 'months').format('YYYY-MM-DD');
  }

  getDateAfterDays(days: number) {
    return moment().utc().subtract(days, 'days').format('YYYY-MM-DD');
  }


  getMonthDifference(numberOfMonths: any) {
    return moment().subtract(numberOfMonths, 'months').format('YYYY-MM-DD')
  }

  getWeekDifference(numberOfMonths: any) {
    return moment().subtract(numberOfMonths, 'weeks').format('YYYY-MM-DD')
  }

  capitalize(text: string) {
    if (text) {
      return text.trim().split(" ").map((splitVal: string) => {
        splitVal = splitVal.trim();
        if (splitVal.indexOf("(") >= 0 || splitVal.indexOf("[") >= 0 || splitVal.indexOf("{") >= 0) {
          return splitVal;
        } else {
          splitVal = splitVal.toLowerCase();
          splitVal = (splitVal.charAt(0) + "").toUpperCase() + splitVal.substr(1, splitVal.length);
          return splitVal;
        }
      }).join(" ");
    } else {
      return text;
    }
  }
  formatDatewithDay(dateString: string): string {
    const date = new Date(dateString);
    const formatter = new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });

    return formatter.format(date);
  }

  public parseJwt(token: any) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  };

  public navigateRoute(settings: any = {}) {
    console.log(settings);
    if (settings.route == 'login') {
      return;

    }
    let rootPath: string = '/';
    if (settings.type == 'User') {
      rootPath = rootPath + AppRoutes.User.ROOT;
    }
    if (settings.type == 'Manager') {
      rootPath = rootPath + AppRoutes.Manager.ROOT;
    }
    if (settings.type) {
      rootPath = rootPath + "/" + settings.route;
    } else {
      rootPath = rootPath + settings.route;
    }

    if (settings.routeData) {
      if (settings.routeData.encryptedText) {
        this.router.navigate([rootPath, settings.routeData.shipmentId, settings.routeData.encryptedText])
      }
      else {
        this.router.navigate([rootPath, settings.routeData]);
      }
    }
    else {
      this.router.navigateByUrl(rootPath);
    }
  }

  navigateRouteWithState(route: any) {
    let rootPath: string = '/';
    if (route.type && route.type == 'Manager') {
      rootPath = rootPath + AppRoutes.Manager.ROOT + "/" + route.route;
    }
    if (route.type && route.type == 'User') {
      rootPath = rootPath + AppRoutes.User.ROOT + "/" + route.route;
    }
    const navigationExtras = {
      state: route.routeData ? route.routeData : {}
    };
    if (route?.routeData) {
      this.router.navigate(
        [rootPath], navigationExtras // Pass selectedUser as state data
      );
    }
  }

  getUser() {
    return this.storageService.getItem('email');
  }

  public getRoute(settings: any = {}) {
    let rootPath: string = '/';
    if (settings.type == 'User') {
      rootPath = rootPath + AppRoutes.User.ROOT;
    }
    if (settings.type == 'Manager') {
      rootPath = rootPath + AppRoutes.Manager.ROOT;
    }
    if (settings.type) {
      rootPath = rootPath + "/" + settings.route;
    } else {
      rootPath = rootPath + settings.route;
    }
    return rootPath;
  }

  getCustomerUserManual() {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("docType", 'Help')
    return this.http.get(UserEndPoint.CommonService.DOWNLOAD_USER_MANUAL, { params: queryParams });
  }

  getSortedArray(array: any, field: string = 'name') {
    return array.sort((a: any, b: any) => (a[field] > b[field]) ? 1 : ((b[field] > a[field]) ? -1 : 0))
  }

  getDocumentType(shipmentId: any) {
    let params = new HttpParams();
    params = params.append("shipmentId", shipmentId);
    return this.http.get(UserEndPoint.smartDocuments.DOCUMENT_TYPES, { params: params });
  }

  getDocumentDistributionList(shipmentId: any) {
    let params = new HttpParams();
    params = params.append("shipmentId", shipmentId);
    return this.http.get(UserEndPoint.smartDocuments.DOCUMENT_DISTRIBUTION_LIST, { params: params });
  }
  extractFilename(contentDisposition: string | null): string | null {
    if (!contentDisposition) {
      return null;
    }

    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    return match && match[1] ? match[1] : null;
  }

  downLoadFile(data: any, fileName: string) {
    const anchorElement = document.createElement('a');
    document.body.appendChild(anchorElement);
    anchorElement.style.display = 'none';
    const json = JSON.stringify(data);
    const blob = new Blob([json], { type: 'application/octet-stream', });
    const url = window.URL.createObjectURL(blob);
    anchorElement.href = url; anchorElement.download = fileName; anchorElement.click();
    window.URL.revokeObjectURL(url);
  }

  displayPdf(pdfData: ArrayBuffer, filename: string): void {
    const blob = new Blob([pdfData], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(blob);
    const newWindow = window.open(pdfUrl, '_blank');
    if (newWindow) {
      newWindow.document.title = filename;
    }
  }

  showToast(severity: string, summary: string, detail: string, duration: number = 5000, sticky: boolean = false, closable: boolean = true, key: string = '') {
    this.messageService.add({
      severity: severity,
      summary: summary,
      detail: detail,
      life: duration,
      sticky: sticky,
      closable: closable,
      key: key
    });

    // Automatically clear the toast after the duration if it's not sticky
    if (!sticky) {
      setTimeout(() => {
        this.messageService.clear(key);
      }, duration);
    }
  }

}